import { makeStyles } from "tss-react/mui";
import { MiIcon } from "@miplatform/components";
import { getWorkOrderTabStats } from "@miplatform/utils";
import { Box } from "@mui/material";

export function WorkOrderCount({ order }) {
  const { classes, theme } = useStyles();

  const { icon, color, count } = getWorkOrderTabStats(theme, order?.workOrders);

  return (
    <Box className={classes.textContainter}>
      <MiIcon
        path={icon}
        size={0.7}
        color={color}
        style={{
          marginBottom: theme.spacing(0.5),
        }}
      />
      {count}
    </Box>
  );
}

const useStyles = makeStyles()((theme) => ({
  textContainter: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(0.5),
  },
}));
